module.exports = __webpack_public_path__ + "img/diao_guan_ji.baab955c.png";